import BaseUser from "./BaseUser";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class Developer extends BaseUser {
  private static readonly _EMAIL: number = 0;
  private _email: string = "";
  public constructor(d3eParams?: Partial<{ email: string }>) {
    super();

    this.setEmail(d3eParams?.email ?? "");
  }
  public get d3eType(): string {
    return "Developer";
  }
  public get email(): string {
    return this._email;
  }
  public setEmail(val: string): void {
    let isValChanged: boolean = this._email !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(Developer._EMAIL, this._email);

    this._email = val;

    this.fire("email", this);
  }
  public get(field: number): any {
    switch (field) {
      case Developer._EMAIL: {
        return this._email;
      }
      default: {
        return super.get(field);
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): Developer {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {
    super.collectChildValues(ctx);
  }
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    super.deepCloneIntoObj(dbObj, ctx);

    let obj: Developer = dbObj as Developer;

    obj.setEmail(this._email);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case Developer._EMAIL: {
        this.setEmail(value as string);
        break;
      }
      default: {
        super.set(field, value);
      }
    }
  }
}
